<template>
  <modal-wrapper
    ref="modalRef"
    :display-cancel-button="false"
    :header="$t('missingMainFilesModal.missingMainFiles')"
    @ok-button-click="hide"
  >
    <div class="warning-text mb-2 font-semibold">
      {{ $t('missingMainFilesModal.description') }}
    </div>
    <ul>
      <li v-for="file in recordsWithoutMainFiles" :key="file">{{ file }}</li>
    </ul>
  </modal-wrapper>
</template>

<script lang="ts" setup>
  import { useModalWrapper } from '../ModalWrapper';

  defineProps<{
    /** `documentId`s of records without main files */
    recordsWithoutMainFiles: string[];
  }>();

  const { modalRef, show, hide } = useModalWrapper();
  defineExpose({ show, hide });
</script>

<style lang="scss" scoped>
  .section-header {
    font-size: 1.1rem;
    line-height: 1.2;
  }
  ul {
    list-style-type: disc;
    margin-left: 1rem;

    li {
      font-size: 1rem;
    }
    margin-bottom: 0.5rem;
  }
</style>
